<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="alterProcedimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterar Procedimento</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="spinner-border" role="status" v-if="loading">
                          <span class="sr-only">Loading...</span>
                        </div>
                        <template v-else>
                            <template v-if="item.marcacao">
                                <paciente-titulo 
                                    
                                    :paciente="item.marcacao.paciente"
                                    :cadastro_temporario="item.marcacao.cadastro_temporario"
                                    :marcacao="item.marcacao" />
                                <p class="lead alert alert-info mt-3 d-flex justify-content-between">
                                    <span>{{ item.marcacao.procedimento.search }}</span>
                                    <span class="text-right">{{ item.marcacao.medico.search }}</span>
                                </p>
                            </template>

                            <template v-if="procs.length">
                                <div>Selecione o Procedimento:</div>

                                <az-input
                                    icon="fa fa-search"
                                    placeholder="Pesquisar..."
                                    v-model="search" />

                                <div class="list-group">
                                    <button type="button" class="list-group-item list-group-item-action" 
                                        :class="proc.selecionado ? 'active' : ''"
                                        v-for="(proc, idx) in lista" :key="idx"
                                        @click="alterar(proc)" :disabled="$store.state.loading">
                                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="proc.selecionado && $store.state.loading">
                                          <span class="sr-only">Loading...</span>
                                        </div>
                                        {{ proc.search }}
                                        <span class="badge badge-secondary ml-2">#{{ proc.id_procedimento }}</span>
                                    </button>
                                </div>
                            </template>
                            <template v-else>
                                <div>Nenhum procedimento disponível</div>
                            </template>
                        </template>
                        <pre v-if="1 == 0">{{ procs }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import PacienteTitulo from '../../shared/PacienteTitulo.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return {
            item: null,
            procs: [],
            loading: false, 
            alterando: false, 
            search: "", 
        }
    },

    components: { 
        PacienteTitulo,
        AzInput, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.procs && this.procs.length ? 
                this.procs.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : [];
        }
    },

    methods: { 
        abrir(item, guia = false) { 
            this.search = "";
            this.loading = true;
            
            let dado = { ...item };

            if ( !dado.marcacao && item.procedimento ) { 
                dado.marcacao = {};
            }

            if ( !guia && !dado.marcacao.procedimento && item.procedimento ) { 
                dado.marcacao.id_procedimento = item.procedimento.id_procedimento;
                dado.marcacao.procedimento = item.procedimento;
                dado.marcacao.id_medico = item.medico.id_pessoa;
                dado.marcacao.medico = item.medico;
                dado.marcacao.id_plano = item.plano.id_plano;
                dado.marcacao.plano = item.plano;
                dado.marcacao.id_solicitacao_autorizacao = item.id_solicitacao_autorizacao;
            }

            this.item = _.cloneDeep(dado);

            $('#alterProcedimentoModal').modal('show');

            let parms;

            if ( guia ) { 
                parms = { 
                    id_medico: guia.executante.id_pessoa,
                    naguia: true,
                    id_guia: guia.id_guia, 
                };
            } else {
                parms = { 
                    id_agenda: item.id_agenda,
                    ...this.item.marcacao, 
                };
            }
            
            this.$util.loadItem(this, { 
                service: "agendas",
                func: "procedimentos_para_alterar",
                parms: parms
            })
            .then(res => { 
                this.procs = res;
            })
            .finally(() => { 
                this.loading = false;
            });
        },

        alterar(proc) { 
            proc.selecionado = true; 

            if ( this.item.marcacao ) { 

                this.$util.atualizar(this, { 
                    service: "agendas",
                    func: "alterar_procedimento", 
                    dados: { 
                        id_solicitacao_autorizacao: this.item.marcacao.id_solicitacao_autorizacao,
                        id_marcacao: this.item.marcacao.id_marcacao,
                        id_procedimento: proc.id_procedimento, 
                        id_atendimento_procedimento_guia: this.item.id_atendimento_procedimento_guia,  
                    },
                    modal: "alterProcedimentoModal",
                    callback: () => { 
                        this.$emit("refresh");
                    },
                    final: () => { 
                        proc.selecionado = false;
                    }
                });

            } else { 

                this.$util.atualizar(this, { 
                    service: "agendas",
                    func: "alterar_procedimento_guia", 
                    dados: { 
                        id_atendimento_procedimento_guia: this.item.id_atendimento_procedimento_guia,  
                        id_procedimento: proc.id_procedimento, 
                    },
                    modal: "alterProcedimentoModal",
                    callback: () => { 
                        this.$emit("refresh");
                    },
                    final: () => { 
                        proc.selecionado = false;
                    }
                });

            }
        }
    }
}
</script>